import { loadNextPage, nextPage } from '../modules/archive/ajax-load'

window.infinite = function (wrapper) {
	return {
		loading: false,
		position: 0,
		trigger: null,
		scrolling: false,
		archiveWrapper: wrapper,
		setup () {
			if (this.getScrollPosition()) {
				$(window).scrollTop(this.getScrollPosition())
			}
			this.attachScrollListener();
		},
		attachScrollListener () {
			this.trigger = document.querySelector('.infinite-trigger');
			window.addEventListener('scroll', () => {
				this.scrolling = true;
			});
			setInterval(() => {
				if (this.scrolling) {
					this.saveScrollPosition()
					this.scrolling = false;
					if (this.shouldLoad()) {
						this.loadMore()
					}
				}
			}, 300);
		},
		getScrollPosition () {
			return history.state ? history.state.scrollTop : null
		},
		saveScrollPosition () {
			history.pushState({
				scrollTop: $(window).scrollTop(),
			}, '');
		},
		loadMore () {
			this.loading = true;
			loadNextPage(this.archiveWrapper).finally(() => {
				this.loading = false;
			})
		},
		shouldLoad () {
			return nextPage() && !this.loading && this.inView() && this.scrollingDown();
		},
		scrollingDown () {
			if (this.trigger) {
				const rect = this.trigger.getBoundingClientRect();
				let scrollingDown = rect.top < this.position;
				this.position = rect.top;
				return scrollingDown
			}
			return false;
		},
		inView () {
			if (this.trigger) {
				const rect = this.trigger.getBoundingClientRect();
				return (
					rect.top >= 0 &&
					rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
				);
			}
			return false;
		},
	}
}